import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { colors } from '../../styles/vars/colors.style'
import { Label } from '../../styles/vars/textStyles.style'
import { mq } from '../../styles/vars/media-queries.style'

export const ExpeditionRouteMain = styled.div`
  display: none;
  height: ${props => props.vHeight}vw;
  pointer-events: none;
  position: absolute;
  ${clamp('right', 22, 49, breakpoints.mobile, breakpoints.contained)}
  right: 0;
  top: 0;
  transform: scale(0.9);
  transform-origin: 100% 0%;
  width: ${props => props.vWidth}vw;

  ${mq.tabletL} {
    display: block;
  }

  @media (min-width: 2220px) {
    transform: scale(0.8);
  }
`

export const SingleRouteMain = styled.div`
  height: 100%;
  width: 100%;
`

export const SingleRoutePath = styled.div`
  position: absolute;
  ${props => (props.left !== undefined ? `left: ${props.left}%;` : ``)}
  ${props => (props.right !== undefined ? `right: ${props.right}%;` : ``)}
  ${props => (props.top !== undefined ? `top: ${props.top}%;` : ``)}
  ${props => (props.width !== undefined ? `width: ${props.width}%;` : ``)}
  z-index: ${props => props.zIndex};
`

export const SingleRouteLocation = styled.div`
  position: absolute;
  ${clamp('height', 11, 61, breakpoints.mobile, breakpoints.contained, true)}
  ${clamp('width', 11, 61, breakpoints.mobile, breakpoints.contained, true)}
  ${props => (props.left !== undefined ? `left: ${props.left}%;` : ``)}
  ${props => (props.right !== undefined ? `right: ${props.right}%;` : ``)}
  ${props => (props.top !== undefined ? `top: ${props.top}%;` : ``)}
`

export const SingleRouteLabel = styled(Label)`
  align-items: center;
  display: flex;
  left: ${props => (props.right ? `100%` : `auto`)};
  ${clamp(
    'margin-top',
    -5,
    -8,
    breakpoints.mobile,
    breakpoints.contained,
    true
  )}
  opacity: 0;
  position: absolute;
  right: ${props => (props.left ? `100%` : `auto`)};
  top: 50%;
  transform: translateX(${props => (props.left ? `-1.2` : `1.2`)}rem)
    translateY(2rem);
  white-space: nowrap;

  svg {
    ${clamp('height', 12, 14, breakpoints.mobile, breakpoints.contained, true)}
    margin-left: ${props => (props.left ? `.7` : `0`)}rem;
    margin-right: ${props => (props.right ? `.7` : `0`)}rem;
    ${clamp('width', 10, 11, breakpoints.mobile, breakpoints.contained, true)}
  }
`

export const SingleRoutePhoto = styled.div`
  background-color: ${colors.darkTeal};
  background-image: url(${props => props.bgImage});
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 50%;
  height: 100%;
  left: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  transform: scale(0.82);
  width: 100%;
`
